import * as t from "io-ts";
import { CommContext } from "./CommContext";

export const ApiEvent = t.intersection([
  t.type({
    method: t.union([
      t.literal("get"),
      t.literal("post"),
      t.literal("put"),
      t.literal("delete"),
    ]),
    resource: t.string,
    resource_id: t.string,
    action: t.string,
  }),
  t.partial({
    resource_data: t.record(t.string, t.unknown),
    comm_context: CommContext,
    error: t.string,
  }),
]);

export interface ApiEvent {
  method: "get" | "post" | "put" | "delete";
  resource: string;
  resource_id: string;
  action: string;
  resource_data?: Record<string, unknown>;
  comm_context?: CommContext;
  error?: string;
}
